<template>
    <div>
        <modal :show.sync="showModal" size="lg">
            <h6 slot="header" class="modal-title">Detalle Ventas </h6>
            <h6 class="mb-3">Desde {{ periodo.desde }} - Hasta {{ periodo.hasta }}</h6>
            <div class="row">
                <div class="col-md-12">
                    <ul class="list-group list-group-flush list my--3">
                        <li class="list-group-item px-0" v-for="(vendedor, index) in vendedores" :key="index">
                            <div class="row align-items-center">
                                
                                <div class="col">
                                    <small>Vendedor:</small>
                                    <h5 class="mb-0">{{vendedor.name}}</h5>
                                </div>
                                <div class="col">
                                    <small>Planes vendidos:</small>
                                    <h5 class="mb-0">{{ vendedor.planes_vendidos }}</h5>
                                </div>
                                <div class="col">
                                    <small>Monto:</small>
                                    <h5 class="mb-0">$ {{ vendedor.monto.toFixed(2) }}</h5>
                                </div>
                            </div>
                        </li>

                        
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="card-body">
                    <h3 class="card-title mb-3">Total sucursal:</h3>
                    <p class="card-text mb-4">$ {{ monto  }}</p>
                </div> 
            </div>
        </modal>
    </div>
</template>


<script>
export default {
    data(){
        return {
            vendedores: undefined,
            periodo: {
                desde: undefined,
                hasta: undefined
            },
            id: undefined,
            nombre: undefined,
            planes_vendidos: undefined,
            monto: undefined,
            showModal: false,
        }
    },
    created()
    {
        this.$parent.$on('openModalVentasSucursal', (data) => {
            this.vendedores = [];
            console.log(data.sucursal.vendedores);
            this.vendedores = data.sucursal.vendedores.sort((a,b) => a.monto-b.monto);
            this.periodo.desde = data.extras.split(" a ")[0];
            this.periodo.hasta = data.extras.split(" a ")[1];
            this.id = data.sucursal.id;
            this.nombre = data.sucursal.name;
            this.planes_vendidos = data.sucursal.planes_vendidos;
            this.monto = data.sucursal.monto.toFixed(2);
            this.showModal = true;
        });
    }
}
</script>